import React, { FunctionComponent } from 'react';
import { Card, CardContent, Stack, Typography } from '@mui/material';

export interface IFeature {
  imgName: string;
  title: string;
  description: string;
  bgColor: string;
}

interface FeatureCardProps {
  feature: IFeature;
}

const FeatureCard: FunctionComponent<FeatureCardProps> = ({ feature }) => {
  return (
    <Card
      elevation={0}
      sx={{ backgroundColor: feature.bgColor, borderRadius: '20px' }}
    >
      <CardContent style={{ padding: '30px 50px' }}>
        <Stack direction="row" alignItems="center" gap="18px">
          <img
            src={`${process.env.PUBLIC_URL}/images/billing/features/${feature.imgName}`}
            alt="quizzes-feature"
            style={{ width: '46px', height: '46px' }}
          />
          <Stack>
            <Typography
              fontWeight={600}
              fontSize="18px"
              color="#1E293B"
              mb="16px"
            >
              {feature.title}
            </Typography>
            <Typography fontWeight={500} fontSize="16px">
              {feature.description}
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default FeatureCard;
